import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import AppPrefixUtils from '../utils/AppPrefixUtils';
import { BreadCrumb } from 'primereact';

function BaseBreadCrumb(props) {
    const itemsMappedToValidArray =  props.items.map((el, index)=>{
        el.label = el.name;
        if(props.items.length -1 === index){
            el.className="current-window"
        }
        el.command = (e)=>{
            if(props.items.length -1 === index){
                return
            }
            props.history.push(AppPrefixUtils.locationHrefUrl(e.item.url));
        };
        return el;
    })
    const home = { icon: 'pi pi-home', url: '/dashboard', command:(e)=>{
        props.history.push(AppPrefixUtils.locationHrefUrl(e.item.url))
    }}

    return (<div className="breadcrumb-custom-div">
        <BreadCrumb home={home} model={itemsMappedToValidArray} onClick={(e)=>{
            e.stopPropagation(); e.preventDefault()}}  ></BreadCrumb>

    </div>

        
    );
}
export default withRouter(BaseBreadCrumb);
